<!-- ── TRIGGER LINK (wrap any content, e.g. a button or icon) ── -->
<a href="javascript:void(0)" (click)="showLoanApplicationForm()">
    <ng-content></ng-content>
</a>

<!-- ── MODAL ── -->
<div class="modal fade in" [id]="'LoanAppForm' + (index !== undefined && index !== null ? index : 'default')"
    tabindex="-1" role="dialog" aria-labelledby="loanAppModalLabel" data-backdrop="false"
    style="background-color: rgba(0,0,0,0.5); overflow: auto; color: #222 !important;">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header" style="padding: 0.375rem 0.75rem; border-bottom: 1px solid #dee2e6;">
                <h6 class="modal-title" id="loanAppModalLabel">
                    <i class="fas fa-file-alt mr-2"></i> Loan Application Form
                    <!-- <span *ngIf="data?.applicationNo" class="text-muted ml-2" style="font-size:0.75rem;">
                        # {{ data.applicationNo }}
                    </span> -->
                </h6>
                <div class="d-flex align-items-center">
                    <!-- Print Button -->
                    <button *ngIf="!loading && resData" type="button" class="btn font-size-12 button-btn mr-2"
                        (click)="print()">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <!-- Close Button -->
                    <button type="button" (click)="OnClose()" class="close mb-1" aria-label="Close">
                        <span aria-hidden="true">
                            <i class="far text-black fa-times-circle"></i>
                        </span>
                    </button>
                </div>
            </div>

            <!-- Modal Body -->
            <div class="modal-body p-3" style="max-height: 85vh; overflow-y: auto;">

                <!-- Loading Spinner -->
                <div *ngIf="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-muted">Loading Loan Application Form...</p>
                </div>

                <!-- ── PRINTABLE CONTENT ── -->
                <div id="loanAppPrintSection" *ngIf="!loading && resData">

                    <!-- ===== HEADER ===== -->
                    <div class="laf-header">
                        <div class="laf-header-left">
                            <div class="laf-app-label">LOAN APPLICATION FORM</div>
                            <div class="laf-meta">Application Number</div>
                            <div class="laf-meta"><strong class="laf-company-name">{{ data.applicationNo }}</strong>
                            </div>
                        </div>
                        <div class="laf-header-center">
                            <img src="{{ EmployeeProfileBaseUrl }}logo.png" alt="Company Logo"
                                class="laf-company-logo mb-2" height="100" width="200" />
                            <div class="laf-company-name"> {{systemconfig?.CompanyName}} </div>
                            <div class="laf-cin">CIN: {{ systemconfig?.CompanyRegNo || '' }}
                            </div>
                        </div>
                        <div class="laf-header-right">
                            <div class="laf-regd-label">Regd. Office/Corp Office:</div>
                            <div class="laf-regd-addr">
                                {{systemconfig?.CompanyCorporateOfficeAddress}}<br>
                                Customer Care Id - {{systemconfig?.ComapnyEmail}}
                            </div>
                            <div class="laf-care">Customer Care No - {{systemconfig?.CompanyPhoneNo}}</div>
                        </div>
                    </div>

                    <!-- ===== APPLICANT DETAILS ===== -->
                    <div class="laf-section" *ngIf="primaryApplicant">
                        <div class="laf-section-title">Applicant Details</div>

                        <div class="laf-sub-title">Personal Detail</div>
                        <table class="laf-table">
                            <tr>
                                <th>Name</th>
                                <td colspan="6"><strong>{{ primaryApplicant.Customer_Name }}</strong></td>
                                <td rowspan="6" class="laf-photo-cell">
                                    <img src="{{ customerProfileBaseUrl }}{{ primaryApplicant.CustomerId }}/{{ primaryApplicant.Customer_ProfilePic }}"
                                        alt="Applicant Photo"
                                        onerror="this.onerror=null; this.src='assets/images/default-user.png';"
                                        class="laf-applicant-photo" height="200" />
                                </td>
                            </tr>
                            <tr>
                                <th>DOB</th>
                                <td>{{ formatDate(primaryApplicant.Customer_DOB) }}</td>
                                <th>Customer Type</th>
                                <td>{{ primaryApplicant.Customer_IsFirm === 'True' ? 'FIRM' : 'INDIVIDUAL' }}</td>
                            </tr>
                            <tr>
                                <th>Gender</th>
                                <td>{{ primaryApplicant.Gender }}</td>
                                <th>Father's Name</th>
                                <td>{{ primaryApplicant.Relation_Name }}</td>
                            </tr>
                            <tr>
                                <th>Category</th>
                                <td>{{ primaryApplicant.Category || 'SC/ST' }}</td>
                                <th>Marital Status</th>
                                <td>{{ primaryApplicant.Marital_Status || 'MARRIED' }}</td>
                            </tr>
                            <tr>
                                <th>Mobile Number</th>
                                <td>{{ primaryApplicant.Customer_PhoneNo }}</td>
                                <th>Religion</th>
                                <td></td>
                            </tr>
                            <tr>
                                <th>No of Dependents</th>
                                <td>1</td>
                                <th>Email</th>
                                <td><span *ngIf="currentUser?.IsMaskingMobile">{{ (primaryApplicant.Customer_Email || '—') | emailmask }}</span><span *ngIf="!currentUser?.IsMaskingMobile">{{ primaryApplicant.Customer_Email || '—' }}</span></td>
                            </tr>

                        </table>

                        <div class="laf-sub-title mt-2">Current Address</div>
                        <table class="laf-table">
                            <tr>
                                <th>Address</th>
                                <td colspan="3">
                                    {{ primaryApplicant.Address1 }}, {{ primaryApplicant.Tehsil1 }},
                                    {{ primaryApplicant.District1 }}, {{ primaryApplicant.State1 }} - {{
                                    primaryApplicant.PIN1 }}
                                </td>
                            </tr>
                            <tr>
                                <th>Village / Tehsil</th>
                                <td>{{ primaryApplicant.Tehsil1 || '—' }}</td>
                                <th>District</th>
                                <td>{{ primaryApplicant.District1 }}</td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{ primaryApplicant.State1 }}</td>
                                <th>Pin Code</th>
                                <td>{{ primaryApplicant.PIN1 }}</td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">Permanent Address</div>
                        <table class="laf-table">
                            <tr>
                                <th>Address</th>
                                <td colspan="3">
                                    {{ primaryApplicant.Address2 || primaryApplicant.Address1 }},
                                    {{ primaryApplicant.District2 || primaryApplicant.District1 }},
                                    {{ primaryApplicant.State2 || primaryApplicant.State1 }} -
                                    {{ primaryApplicant.PIN2 || primaryApplicant.PIN1 }}
                                </td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{ primaryApplicant.State2 || primaryApplicant.State1 }}</td>
                                <th>Pin Code</th>
                                <td>{{ primaryApplicant.PIN2 || primaryApplicant.PIN1 }}</td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">Employment / Business Detail [Income Earner]</div>
                        <div class="laf-sub-sm">Business 1</div>
                        <table class="laf-table">
                            <tr>
                                <th>Organization / Occupation</th>
                                <td>{{ primaryApplicant.Profile || 'SELF EMPLOYED' }}</td>
                                <th>Nature Of Occupation</th>
                                <td>{{ primaryApplicant.Nature_of_work }}</td>
                            </tr>
                            <tr>
                                <th>Business Category</th>
                                <td>{{ primaryApplicant.BusinessCategory || '—' }}</td>
                                <th>Estimated Gross Monthly Income (Rs.)</th>
                                <td>{{ getTotalIncome(primaryApplicant.CustomerId) | number }}</td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">KYC Detail</div>
                        <table class="laf-table">
                            <thead>
                                <tr>
                                    <th>Document Type</th>
                                    <th>Document ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let doc of getCustomerKyc(primaryApplicant.CustomerId)">
                                    <td>{{ doc.Doc_Name }}</td>
                                    <td>{{ maskDocumentNumber(doc.KYC_DocNumber, doc.Doc_Name) }}</td>
                                </tr>
                                <tr *ngIf="getCustomerKyc(primaryApplicant.CustomerId).length === 0">
                                    <td colspan="2" class="text-center text-muted">No KYC documents</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- ===== CO-APPLICANTS ===== -->
                    <div class="laf-section" *ngFor="let co of coApplicants; let i = index">
                        <div class="laf-section-title">Co-Applicant {{ i + 1 }} Details — {{ co.Customer_Name }}</div>

                        <div class="laf-sub-title">Personal Detail</div>
                        <table class="laf-table">
                            <tr>
                                <th>Name</th>
                                <td colspan="6"><strong>{{ co.Customer_Name }}</strong></td>
                                <td rowspan="6" class="laf-photo-cell">
                                    <img src="{{ customerProfileBaseUrl }}{{ co.CustomerId }}/{{ co.Customer_ProfilePic }}"
                                        alt="Applicant Photo"
                                        onerror="this.onerror=null; this.src='assets/images/default-user.png';"
                                        class="laf-applicant-photo" height="200" />
                                </td>
                            </tr>
                            <tr>
                                <th>DOB</th>
                                <td>{{ formatDate(co.Customer_DOB) }}</td>
                                <th>Customer Type</th>
                                <td>{{ co.Customer_IsFirm === 'True' ? 'FIRM' : 'INDIVIDUAL' }}</td>
                            </tr>
                            <tr>
                                <th>Gender</th>
                                <td>{{ co.Gender }}</td>
                                <th>Father's Name</th>
                                <td>{{ co.Relation_Name }}</td>
                            </tr>
                            <tr>
                                <th>Category</th>
                                <td>{{ co.Category || 'SC/ST' }}</td>
                                <th>Marital Status</th>
                                <td>{{ co.Marital_Status || 'MARRIED' }}</td>
                            </tr>
                            <tr>
                                <th>Mobile Number</th>
                                <td>{{ co.Customer_PhoneNo }}</td>
                                <th>Religion</th>
                                <td></td>
                            </tr>
                            <tr>
                                <th>No of Dependents</th>
                                <td>1</td>
                                <th>Email</th>
                                <td><span *ngIf="currentUser?.IsMaskingMobile">{{ (co.Customer_Email || '—') | emailmask }}</span><span *ngIf="!currentUser?.IsMaskingMobile">{{ co.Customer_Email || '—' }}</span></td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">Current Address</div>
                        <table class="laf-table">
                            <tr>
                                <th>Address</th>
                                <td colspan="3">
                                    {{ co.Address1 }}, {{ co.Tehsil1 }},
                                    {{ co.District1 }}, {{ co.State1 }} - {{
                                    co.PIN1 }}
                                </td>
                            </tr>
                            <tr>
                                <th>Village / Tehsil</th>
                                <td>{{ co.Tehsil1 || '—' }}</td>
                                <th>District</th>
                                <td>{{ co.District1 }}</td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{ co.State1 }}</td>
                                <th>Pin Code</th>
                                <td>{{ co.PIN1 }}</td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">Permanent Address</div>
                        <table class="laf-table">
                            <tr>
                                <th>Address</th>
                                <td colspan="3">
                                    {{ co.Address2 || co.Address1 }},
                                    {{ co.District2 || co.District1 }},
                                    {{ co.State2 || co.State1 }} -
                                    {{ co.PIN2 || co.PIN1 }}
                                </td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{ co.State2 || co.State1 }}</td>
                                <th>Pin Code</th>
                                <td>{{ co.PIN2 || co.PIN1 }}</td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">
                            Employment / Business Detail
                            [{{ getTotalIncome(co.CustomerId) > 0 ? 'Income Earner' : 'Non-Income Earner' }}]
                        </div>
                        <table class="laf-table" *ngIf="getTotalIncome(co.CustomerId) > 0">
                            <tr>
                                <th>Organization / Occupation</th>
                                <td>{{ co.Profile || '—' }}</td>
                                <th>Nature Of Occupation</th>
                                <td>{{ co.Nature_of_work || '—' }}</td>
                            </tr>
                            <tr>
                                <th>Business Category</th>
                                <td>{{ co.BusinessCategory || '—' }}</td>
                                <th>Estimated Gross Monthly Income (Rs.)</th>
                                <td>{{ getTotalIncome(co.CustomerId) | number }}</td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">KYC Detail</div>
                        <table class="laf-table">
                            <thead>
                                <tr>
                                    <th>Document Type</th>
                                    <th>Document ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let doc of getCustomerKyc(co.CustomerId)">
                                    <td>{{ doc.Doc_Name }}</td>
                                    <td>{{ maskDocumentNumber(doc.KYC_DocNumber, doc.Doc_Name) }}</td>
                                </tr>
                                <tr *ngIf="getCustomerKyc(co.CustomerId).length === 0">
                                    <td colspan="2" class="text-center text-muted">No KYC documents</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- ===== GUARANTORS ===== -->
                    <div class="laf-section" *ngFor="let g of guarantors; let j = index">
                        <div class="laf-section-title">Guarantor {{ j + 1 }} Details — {{ g.Customer_Name }}</div>

                        <div class="laf-sub-title">Personal Detail</div>
                        <table class="laf-table">
                            <tr>
                                <th>Name</th>
                                <td colspan="3"><strong>{{ g.Customer_Name }}</strong></td>
                            </tr>
                            <tr>
                                <th>DOB</th>
                                <td>{{ formatDate(g.Customer_DOB) }}</td>
                                <th>Gender</th>
                                <td>{{ g.Gender }}</td>
                            </tr>
                            <tr>
                                <th>Father's Name</th>
                                <td>{{ g.Relation_Name }}</td>
                                <th>Mobile</th>
                                <td>{{ g.Customer_PhoneNo }}</td>
                            </tr>
                            <tr>
                                <th>Category</th>
                                <td>{{ g.Category || 'SC/ST' }}</td>
                                <th>Marital Status</th>
                                <td>{{ g.Marital_Status || 'MARRIED' }}</td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">Permanent Address</div>
                        <table class="laf-table">
                            <tr>
                                <th>Address</th>
                                <td colspan="3">
                                    {{ g.Address1 || g.Address2 }}, {{ g.District1 || g.District2 }},
                                    {{ g.State1 || g.State2 }} - {{ g.PIN1 || g.PIN2 }}
                                </td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">Employment / Business Detail [Income Earner]</div>
                        <div class="laf-sub-sm">Business 1</div>
                        <table class="laf-table">
                            <tr>
                                <th>Organization / Occupation</th>
                                <td>{{ g.Profile || 'SELF EMPLOYED' }}</td>
                                <th>Nature Of Occupation</th>
                                <td>{{ g.Nature_of_work || '—' }}</td>
                            </tr>
                            <tr>
                                <th>Business Category</th>
                                <td>{{ g.BusinessCategory || '—' }}</td>
                                <th>Estimated Gross Monthly Income (Rs.)</th>
                                <td>{{ getTotalIncome(g.CustomerId) > 0 ? (getTotalIncome(g.CustomerId) | number) :
                                    '15000–25000' }}</td>
                            </tr>
                        </table>

                        <div class="laf-sub-title mt-2">KYC Detail</div>
                        <table class="laf-table">
                            <thead>
                                <tr>
                                    <th>Document Type</th>
                                    <th>Document ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let doc of getCustomerKyc(g.CustomerId)">
                                    <td>{{ doc.Doc_Name }}</td>
                                    <td>{{ maskDocumentNumber(doc.KYC_DocNumber, doc.Doc_Name) }}</td>
                                </tr>
                                <tr *ngIf="getCustomerKyc(g.CustomerId).length === 0">
                                    <td colspan="2" class="text-center text-muted">No KYC documents</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- ===== REFERENCES ===== -->
                    <div class="laf-section" *ngIf="getGlobalReferences().length > 0">
                        <div class="laf-section-title">References</div>
                        <div *ngFor="let ref of getGlobalReferences(); let ri = index">
                            <div class="laf-sub-sm">Reference Detail {{ ri + 1 }}</div>
                            <table class="laf-table">
                                <tr>
                                    <th>Name</th>
                                    <td>{{ ref.CR_PersonName }}</td>
                                    <th>Mobile Number</th>
                                    <td>{{ ref.CR_ContactNo }}</td>
                                </tr>
                                <tr>
                                    <th>Reference Type</th>
                                    <td>{{ ref.CR_ReferenceType }}</td>
                                    <th>Remarks</th>
                                    <td>OK</td>
                                </tr>
                                <tr>
                                    <th>Address</th>
                                    <td colspan="3">{{ ref.CR_PersonAddress }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <!-- ===== FINANCE REQUIREMENTS ===== -->
                    <div class="laf-section">
                        <div class="laf-section-title">Finance Requirements</div>
                        <table class="laf-table">
                            <tr>
                                <th>Loan Amount (Rs.)</th>
                                <td>{{ data.loan?.Application_LoanAmount | number }}</td>
                                <th>Tenure</th>
                                <td>{{ data.loan?.Application_LoanTenure }} Months</td>
                            </tr>
                            <tr>
                                <th>Interest Type</th>
                                <td>FIXED</td>
                                <th>Product Type</th>
                                <td>{{ data.loan?.Product_Name }}</td>
                            </tr>
                            <tr>
                                <th>Loan Purpose</th>
                                <td colspan="3">{{ data.loan?.Application_LoanPurpose || 'Business / Personal' }}</td>
                            </tr>
                            <tr>
                                <th>ROI (%)</th>
                                <td>{{ data.approvedTerms?.ROI || '—' }}</td>
                                <th>IRR (%)</th>
                                <td>{{ (data.approvedTerms?.IRR || data.loan?.Application_Case_IRR) | number : "1.2-2" }}</td>
                            </tr>
                            <tr>
                                <th>EMI Amount (Rs.)</th>
                                <td>{{ data.loan?.Application_LoanEMIAmount | number }}</td>
                                <th>Agreement Value (Rs.)</th>
                                <td>{{ data.loan?.Application_AgreementValue | number }}</td>
                            </tr>
                            <tr>
                                <th>First EMI Date</th>
                                <td>{{ data.loan?.FirstEMIDate }}</td>
                                <th>Loan Date</th>
                                <td>{{ data.loan?.Loan_Date }}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- ===== REPAYMENT INFO ===== -->
                    <div class="laf-section" *ngIf="getDisbursmentBank()">
                        <div class="laf-section-title">Repayment Information</div>
                        <table class="laf-table">
                            <tr>
                                <th>Document Type</th>
                                <td>{{ getDisbursmentBank()?.PdcType }}</td>
                                <th>Member</th>
                                <td>{{ getDisbursmentBank()?.CUSTOMER_NAME }}</td>
                            </tr>
                            <tr>
                                <th>Bank Name</th>
                                <td>{{ getDisbursmentBank()?.Bankname }}</td>
                                <th>Account No</th>
                                <td>{{ getDisbursmentBank()?.Ac }}</td>
                            </tr>
                            <tr>
                                <th>IFSC Code</th>
                                <td>{{ getDisbursmentBank()?.IFSCCode }}</td>
                                <th>Branch</th>
                                <td>{{ getDisbursmentBank()?.Branch }}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- ===== PROPERTY / SECURITY ===== -->
                    <div class="laf-section" *ngIf="data.asset && data.asset.TypeofProperty_Name">
                        <div class="laf-section-title">Details of Security Offered — Property</div>
                        <div class="laf-sub-sm">Property Detail 1</div>
                        <table class="laf-table">
                            <tr>
                                <th>Property Address</th>
                                <td colspan="3">{{ data.asset.Address }}</td>
                            </tr>
                            <tr>
                                <th>Property Type</th>
                                <td>{{ data.asset.TypeofProperty_Name || 'HOUSE' }}</td>
                                <th>Nature of Property</th>
                                <td>{{ data.asset.NatureofProperty_Name || 'RESIDENTIAL' }}</td>
                            </tr>
                            <tr>
                                <th>Location Type</th>
                                <td>{{ data.asset.LocationType || 'RURAL' }}</td>
                                <th>Ownership</th>
                                <td>{{ data.asset.OwnershipType_Name || 'INDIVIDUAL' }}</td>
                            </tr>
                            <tr>
                                <th>Land Area (Sq. Ft)</th>
                                <td>{{ data.asset.TotalArea }}</td>
                                <th>Built Up Area (Sq. Ft)</th>
                                <td>{{ data.asset.ConstructedArea }}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- ===== FOR OFFICE USE ONLY ===== -->
                    <div class="laf-section">
                        <div class="laf-section-title">For Office Use Only</div>
                        <table class="laf-table">
                            <tr>
                                <th>Branch Name</th>
                                <td>{{ data.loan?.Branch_Name }}</td>
                                <th>Branch Manager</th>
                                <td>{{ data.loan?.BranchHead }}</td>
                            </tr>
                            <tr>
                                <th>Officer Name</th>
                                <td>{{ data.loan?.SalesExecutive }}</td>
                                <th>Employee Code</th>
                                <td>—</td>
                            </tr>
                            <tr>
                                <th>Application No</th>
                                <td>{{ data.applicationNo }}</td>
                                <th>Loan A/C No</th>
                                <td>{{ data.loan?.LoanAcNo }}</td>
                            </tr>
                            <tr *ngIf="primaryApplicant">
                                <th>CIBIL Score (Applicant)</th>
                                <td>{{ getCibilScore(primaryApplicant.CustomerId) }}</td>
                                <th>CIBIL Recommendation</th>
                                <td>{{ getCibilRec(primaryApplicant.CustomerId) }}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- ===== PRE-LOGIN DOCUMENTS ===== -->
                    <div class="laf-section">
                        <div class="laf-section-title">Pre Login Document</div>
                        <div class="laf-body-text">
                            <p><strong>For Individuals</strong></p>
                            <ol>
                                <li>PAN Card / Form 60</li>
                                <li>KYC/OVD (Aadhaar Card, Passport, Driving License and Voter ID)</li>
                                <li>Photocopy of Papers</li>
                                <li>Bank Statement (if available)</li>
                            </ol>
                            <p><strong>For Non Individuals —</strong> Please refer our Website: www.finnaux.com</p>
                            <p>The rate of interest and the approach for gradations of risk and rationale for charging
                                different rate of interest is mentioned on the website: www.finnaux.com</p>
                        </div>
                    </div>

                    <!-- ===== DECLARATION ===== -->
                    <div class="laf-section">
                        <div class="laf-section-title">Declaration</div>
                        <div class="laf-body-text">
                            <p>
                                I/We the undersigned wish to apply to {{currentUser?.CompanyName}} Pvt. Ltd. for a loan
                                of
                                <strong>Rs. {{ data.loan?.Application_LoanAmount | number }}</strong> for
                                <strong>{{ data.loan?.Application_LoanTenure }}</strong> Months.
                                <strong>{{ primaryApplicant?.Customer_Name }}</strong> — I/We declare that the
                                information given in this application form is true &amp; correct, complete and updated
                                in all
                                respects and I/We have not suppressed any information.
                            </p>
                            <p>
                                I/We hereby agree that it shall be my/our sole responsibility to advise the company in
                                the
                                event of any change in the above details/information.
                            </p>
                            <p>
                                <strong>"I/We hereby consent to download my KYC related documents and records from CKYCR
                                    and KYC identifier for CDD purpose. I/We hereby consent to receive information from
                                    CVL KRA
                                    through SMS/Email on the above registered number/Email address."</strong>
                            </p>
                            <p>I/We allow {{currentUser?.CompanyName}} to use our banking details for
                                ECS/NACH/Banking purpose.</p>
                            <p>
                                <em>Login/IMD Fees is non-refundable and adjusted in Processing Fees (PF) for disbursed
                                    loan applications.</em>
                            </p>
                            <p>I/We declare that our all family member total income is above Rs. 25,000.</p>
                            <p>
                                <strong>Important:</strong> Company does not accept any cash except login fee.
                                Cheques/DD should
                                be in favour of " {{currentUser?.CompanyName}} ". Company doesn't accept
                                blank cheques.
                            </p>
                            <p>The loan will not be used for anti-social activities, stock market, or speculative
                                purposes.</p>
                            <p>I/We declare that I/We don't have any relationship with the employees working in
                                {{currentUser?.CompanyName}} .</p>

                            <!-- Signature Row -->
                            <div class="laf-sig-area">
                                <div class="laf-sig-box">
                                    Signature of Applicant<br>
                                    <strong>{{ primaryApplicant?.Customer_Name }}</strong>
                                    <div class="laf-sig-line"></div>
                                </div>
                                <div class="laf-sig-box" *ngFor="let co of coApplicants">
                                    Signature of Co-Applicant<br>
                                    <strong>{{ co.Customer_Name }}</strong>
                                    <div class="laf-sig-line"></div>
                                </div>
                                <div class="laf-sig-box" *ngFor="let g of guarantors">
                                    Signature of Guarantor<br>
                                    <strong>{{ g.Customer_Name }}</strong>
                                    <div class="laf-sig-line"></div>
                                </div>
                            </div>

                            <div class="laf-sig-officer">
                                <div>Signature of Field Officer __________________________________ verified by OTP</div>
                                <div class="mt-1">Signature of Authorised Officer of Company
                                    ________________________________</div>
                            </div>

                            <div class="laf-date-place">
                                <strong>DATED —</strong> {{ today | date: 'dd-MM-yyyy' }}
                                &nbsp;&nbsp;&nbsp;
                                <strong>PLACE —</strong> {{ data.loan?.Branch_Name || 'Jaipur' }}
                            </div>
                        </div>
                    </div>

                    <!-- ===== EMI EXAMPLES ===== -->
                    <div class="laf-section">
                        <div class="laf-section-title">EMI Awareness</div>
                        <div class="laf-body-text">
                            <p><strong>*Understand your EMI with help of examples:</strong></p>
                            <ol>
                                <li>Loan Rs 1,00,000 | 7 years | ROI 23% P.A. → EMI Rs 2,405</li>
                                <li>Loan Rs 1,00,000 | 7 years | ROI 24% P.A. → EMI Rs 2,468</li>
                                <li>Loan Rs 1,00,000 | 7 years | ROI 25% P.A. → EMI Rs 2,531</li>
                                <li>Loan Rs 1,00,000 | 5 years | ROI 23% P.A. → EMI Rs 2,819</li>
                                <li>Loan Rs 1,00,000 | 5 years | ROI 24% P.A. → EMI Rs 2,877</li>
                                <li>Loan Rs 1,00,000 | 5 years | ROI 25% P.A. → EMI Rs 2,935</li>
                            </ol>
                            <p>*Your application will be processed within 45 days from date of application subject to
                                submission of all required documentation.</p>
                            <p><strong>Please ensure to take digital receipt after any payment to
                                    {{currentUser?.CompanyName}} .</strong></p>
                            <p><strong>The Property papers will be made available to your respective branch within 30
                                    days of full repayment / settlement / closure of the loan account.</strong></p>
                        </div>
                    </div>

                    <!-- ===== FOOTER ===== -->
                    <div class="laf-footer">
                        This document is system generated
                    </div>

                </div><!-- /#loanAppPrintSection -->
            </div><!-- /.modal-body -->
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->